import React, { Component } from 'react';
import * as API from '../api.js';
import '../style.css';
import { Redirect } from 'react-router-dom';
import btnAdd from '../icons/btnAdd.svg';
import Dropdown from 'react-bootstrap/Dropdown';
import Menu from '../icons/menu.svg';
import { AnimatedModal } from './Reusable/AnimatedModal'
import dateFormat from 'dateformat';
import { ActivityPopup } from '../ReusableComponents/ActivityPopup.js';
import TableView from '../ReusableComponents/TableView/TableView.js';
import LoaderComponent from '../ReusableComponents/LoaderComponent.js';
import ButtonWithIcon from '../ReusableComponents/ButtonWithIcon.js';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
        href=""
        ref={ref}
        onClick={e => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <img src={Menu} alt="I am alt" />
    </a>
));

class newSubscription extends Component {

    state = {
        addon_name: "",
        addon_desc: "",
        addon_price: "",
        user: {},
        loading: true,
        item_id: '',
        limits: 1,
        items: [],
        plan_id: 0,
        plan_name: '',
        plan_status: '',
        plan_cost: 0,
        plan_discount: 0,
        price_id: '',
        plan_created_date: '',
        popupText: '',
        redirect: false,
        planItems: [],
        itemAddPopup: false,
        addonAddPopup: false,
        isItem: false,
        editItem: false,
        description: "",
        plan_type: "",
        itemName: "",
        showProcessPopup: false,
        processPopupIcon: "",
        processAction: "",
        processMessage: "",
        ok: false,
        tableLoading: true,
        tableState: {
            pageNumber: 1,
            pageSize: 15,
        },
        count: 0,
        zoho_plan_code: "",
        price_interval: '',
        addon_code: "",
        addon_type: "recurring",
        addons: [],
        isArchive: false
    }

    onChangeListener = async (e) => {
        let t = e.target;
        if (t.name != 'plan_discount' && t.name != 'plan_cost') {
            this.setState((state) => ({
                ...state,
                [t.name]: t.value
            }))
        } else if (!isNaN(t.value) && isFinite(t.value)) {
            this.setState((state) => ({
                ...state,
                [t.name]: t.value
            }))
        }
    }

    closeActivityPopup = () => {
        this.setState((state) => ({
            ...state,
            showProcessPopup: false,
            processMessage: null,
            redirect: !this.state.isItem && this.state.ok,
        }))
    }

    getSubscriptionItem = () => {
        API.getSubscriptionItem().then((data) => {
            
            this.setState((state) => ({
                ...state,
                items: data.items,
                item_id: data.items[0].id
            }))
        })
    }

    updateSubscriptionPlan = () => {
        this.setState((state) => ({
            itemName: "Subscription Plan",
            processPopupIcon: "WAIT",
            processAction: "UPDATE",
            processMessage: null,
            showProcessPopup: true,
            isItem: false,
            ok: false
        }))
        let { plan_id, plan_status, plan_cost, plan_discount, description, price_id, plan_type, } = this.state
        API.updateSubscriptionPlan(plan_id, plan_status, null, plan_cost, plan_discount, description, price_id, plan_type, undefined).then((data) => {
            if (data.data) {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Plan",
                    processPopupIcon: "COMPLETE",
                    processAction: "UPDATE",
                    processMessage: null,
                    showProcessPopup: true,
                    ok: true
                }))
            } else {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Plan",
                    processPopupIcon: "ERROR",
                    processAction: "UPDATE",
                    processMessage: data.message,
                    showProcessPopup: true,
                }))
            }
        }, (e) => {
            this.setState((state) => ({
                ...state,
                itemName: "Subscription Plan",
                processPopupIcon: "ERROR",
                processAction: "UPDATE",
                processMessage: e.message,
                showProcessPopup: true,
            }))
        })
    }

    // Update subscription plan item
    updateSubscriptionPlanItem = () => {
        this.setState((state) => ({
            itemName: "Subscription Item",
            processPopupIcon: "WAIT",
            processAction: "UPDATE",
            processMessage: null,
            showProcessPopup: true,
            isItem: true
        }))
        let { item_id, plan_id, limits } = this.state
        API.updateSubscriptionPlanItem(plan_id, item_id, limits).then((data) => {
            if (data.message == "Item updated.") {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Item",
                    processPopupIcon: "COMPLETE",
                    processAction: "UPDATE",
                    processMessage: null,
                    showProcessPopup: true,
                }),
                    () => {
                        this.getSubscriptionPlanItems()
                    })
            } else {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Item",
                    processPopupIcon: "ERROR",
                    processAction: "UPDATE",
                    processMessage: data.message,
                    showProcessPopup: true,
                }))
            }
        }, (e) => {
            this.setState((state) => ({
                ...state,
                itemName: "Subscription Item",
                processPopupIcon: "ERROR",
                processAction: "UPDATE",
                processMessage: e.message,
                showProcessPopup: true,
            }))
        })
    }
    //Save subscription plan item
    addSubPlanItem = () => {
        this.setState((state) => ({
            itemName: "Subscription Item",
            processPopupIcon: "WAIT",
            processAction: "ADD",
            processMessage: null,
            showProcessPopup: true,
            isItem: true
        }))
        let { plan_id, limits, item_id } = this.state
        let res = {}
        API.saveSubscriptionPlanItem(plan_id, item_id, limits).then(async (data) => {
            res = await data.json()
            if (data.status == 200) {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Item",
                    processPopupIcon: "COMPLETE",
                    processAction: "ADD",
                    processMessage: null,
                    showProcessPopup: true,
                    isItem: true
                }), () => {
                    this.getSubscriptionPlanItems()
                })
            } else {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Item",
                    processPopupIcon: "ERROR",
                    processAction: "ADD",
                    processMessage: res.message,
                    showProcessPopup: true,
                    isItem: true
                }))
            }
        }, async (e) => {
            this.setState((state) => ({
                ...state,
                itemName: "Subscription Item",
                processPopupIcon: "ERROR",
                processAction: "ADD",
                processMessage: e,
                showProcessPopup: true,
            }))
        })
    }


    //Save Addon item
    addAddonPlan = () => {
        this.setState((state) => ({
            itemName: "Subscription Addon",
            processPopupIcon: "WAIT",
            processAction: "ADD",
            processMessage: null,
            showProcessPopup: true,
            isItem: true
        }))
        let { plan_id, limits, item_id } = this.state

        this.setState((state) => ({
            showProcessPopup: false,
            isItem: false
        }))
        let res = {}


        API.createAddon(this.state.addon_name, this.state.addon_desc, this.state.addon_price, this.state.addon_type, this.state.price_interval, this.state.addon_code, this.state.zoho_plan_code, this.state.zoho_plan_code).then(async (data) => {

            if (data.message == 'ok') {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Addon",
                    processPopupIcon: "COMPLETE",
                    processAction: "ADD",
                    processMessage: null,
                    showProcessPopup: true,
                    isItem: true
                }), () => {
                    this.getSubscriptionPlanItems()
                })
            } else {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Addon",
                    processPopupIcon: "ERROR",
                    processAction: "ADD",
                    processMessage: res.message,
                    showProcessPopup: true,
                    isItem: true
                }))
            }
        }, async (e) => {
            this.setState((state) => ({
                ...state,
                itemName: "Subscription Addon",
                processPopupIcon: "ERROR",
                processAction: "ADD",
                processMessage: e,
                showProcessPopup: true,
            }))
        })


        
    }


    editAddonPlan = () => {
        this.setState((state) => ({
            itemName: "Subscription Addon",
            processPopupIcon: "WAIT",
            processAction: "EDIT",
            processMessage: null,
            showProcessPopup: true,
            isItem: true
        }))
        let { plan_id, limits, item_id } = this.state

        this.setState((state) => ({
            showProcessPopup: false,
            isItem: false
        }))
        let res = {}


        API.editAddon(this.state.addon_name, this.state.addon_desc, this.state.addon_price, this.state?.addonDetail?.zoho_addon_code).then(async (data) => {

            if (data.message == 'ok') {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Addon",
                    processPopupIcon: "COMPLETE",
                    processAction: "EDIT",
                    processMessage: "Updated Addon detail",
                    showProcessPopup: true,
                    isItem: true
                }), () => {
                    this.getSubscriptionPlanItems()
                })
            } else {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Addon",
                    processPopupIcon: "ERROR",
                    processAction: "EDIT",
                    processMessage: res.message,
                    showProcessPopup: true,
                    isItem: true
                }))
            }
        }, async (e) => {
            this.setState((state) => ({
                ...state,
                itemName: "Subscription Addon",
                processPopupIcon: "ERROR",
                processAction: "EDIT",
                processMessage: e,
                showProcessPopup: true,
            }))
        })



    }

    // Get subscription plan items list unser the plan
    getSubscriptionPlanItems = () => {
        this.setState({ tableLoading: true })
        API.getSubscriptionPlanItems(this.state.plan_id, undefined, this.state.tableState).then((data) => {
            this.setState({
                planItems: data.items,
                loading: false,
                tableLoading: false,
                count: data?.items?.[0]?.total_count || 0,

                addons: data.addons
            })
        })
    }

    // Delete subsciption plan
    deleteSubscriptionPlan = () => {
        API.deleteSubscriptionPlan(this.state.plan_id).then((data) => {
            if (data.message == 'Subscription plan deleted.') {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Plan",
                    processPopupIcon: "COMPLETE",
                    processAction: "DELETE",
                    processMessage: null,
                    showProcessPopup: true,
                    ok: true
                }))
            } else {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Plan",
                    processPopupIcon: "ERROR",
                    processAction: "DELETE",
                    processMessage: data.message,
                    showProcessPopup: true,
                }))
            }
        }, (e) => {
            this.setState((state) => ({
                ...state,
                itemName: "Subscription Plan",
                processPopupIcon: "ERROR",
                processAction: "DELETE",
                processMessage: "Something went wrong",
                showProcessPopup: true,
            }))
        })
    }

    // Delete subsciption plan item
    archiveSubscriptionPlanItem = () => {
        this.setState((state) => ({
            ...state,
            isArchive: false
        }))
        API.archivePlan(this.state.zoho_plan_code).then((data) => {
            if (data.message == 'deleted') {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Item",
                    processPopupIcon: "COMPLETE",
                    processAction: "UPDATE",
                    processMessage: null,
                    showProcessPopup: true,
                }),
                    () => {
                        this.getSubscriptionPlanItems()
                    })
            } else {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Item",
                    processPopupIcon: "ERROR",
                    processAction: "UPDATE",
                    processMessage: data.message,
                    showProcessPopup: true,
                }))
            }
        }, (e) => {
            this.setState((state) => ({
                ...state,
                itemName: "Subscription Plan",
                processPopupIcon: "ERROR",
                processAction: "UPDATE",
                processMessage: "Something went wrong",
                showProcessPopup: true,
            }))
        })
    }

    // Delete subsciption plan item
    deleteSubscriptionPlanItem = () => {
        API.deleteSubscriptionPlanItem(this.state.plan_id, this.state.item_id).then((data) => {
            if (data.message == 'Subscription item deleted.') {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Item",
                    processPopupIcon: "COMPLETE",
                    processAction: "DELETE",
                    processMessage: null,
                    showProcessPopup: true,
                }),
                    () => {
                        this.getSubscriptionPlanItems()
                    })
            } else {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Item",
                    processPopupIcon: "ERROR",
                    processAction: "DELETE",
                    processMessage: data.message,
                    showProcessPopup: true,
                }))
            }
        }, (e) => {
            this.setState((state) => ({
                ...state,
                itemName: "Subscription Plan",
                processPopupIcon: "ERROR",
                processAction: "DELETE",
                processMessage: "Something went wrong",
                showProcessPopup: true,
            }))
        })
    }

    successRedirectComponent = () => {
        if (this.state.redirect) {
            return <Redirect to={{
                pathname: "/admin/allsubscription",
                state: {
                    user: this.state.user,
                }
            }} />
        }
    }

    componentWillMount() {
        document.title = "AeroGCS - Subscription";
        if (this.props.location.state) {
            let { user, plan } = this.props.location.state;

            this.setState({
                user,
                plan_id: plan.id,
                plan_name: plan.plan_name,
                plan_type: plan.plan_type || "Monthly",
                plan_status: plan.status,
                price_id: plan.price_id,
                plan_cost: plan.plan_cost ? plan.plan_cost : 0,
                plan_discount: plan.discount ? plan.discount : 0,
                plan_created_date: plan.created_date,
                description: plan.description,
                zoho_plan_code: plan.zoho_plan_code,
                price_interval: plan.plan_type == 'Monthly' ? "monthly" : plan.plan_type == 'Yearly' ? "yearly" : "monthly",
            }, () => {
                this.getSubscriptionPlanItems()
                this.getSubscriptionItem()
            })
        } else {
            API.getUserType().then(([blah, user]) => {
                this.setState({ user })
            }, (e) => {
                window.location.replace("/login");
            })
        }
    }

    render() {
        return <div className="wrapper">
            <div className="right-content-new"  >
                {this.successRedirectComponent()}
                <div className="top-bar-new"><div className="top-bar-text-new">New Subscription</div></div>
                {this.state.loading ? <LoaderComponent /> :
                    <div className="main-content-new" style={{ background: 'none' }}>
                        <ActivityPopup
                            item={this.state.itemName}
                            open={this.state.showProcessPopup}
                            icon={this.state.processPopupIcon}
                            action={this.state.processAction}
                            msg={this.state.processMessage}
                            close={() => this.closeActivityPopup()}
                            onClickOk={() => { this.state.isItem ? this.deleteSubscriptionPlanItem() : this.state.isArchive ? this.archiveSubscriptionPlanItem() : this.deleteSubscriptionPlan() }}
                        />

                        {/* Add item popup */}
                        <AnimatedModal
                            isOpen={this.state.itemAddPopup}
                            onRequestClose={() => {
                                this.setState((state) => ({
                                    ...state,
                                    inviteModal: false,
                                }))
                            }}
                            height="360px"
                            width="400px"
                        >

                            <div style={{ textAlign: "center", margin: '20px 0px', height: '40px', fontSize: '22px', fontWeight: '500' }}>{this.state.editItem ? "Edit Item Limit" : "Add An Item"}</div>
                            <div style={{ height: '5px', width: '100%' }}><hr /></div>
                            <div style={{ margin: '10px 50px' }}>
                                <div className="add-user-form-label">
                                    Item
                                </div>
                                <div className="add-user-form-text-wrapper">
                                    <select
                                        disabled={this.state.editItem}
                                        name="item_id"
                                        onChange={this.onChangeListener}
                                        value={this.state.item_id}
                                        className="sub-add-user-form-text"
                                    >
                                        {this.state.items.map((item) => {
                                            return <option value={item.id}>{item.item_name}</option>
                                        })
                                        }
                                    </select>
                                </div>
                                <div className="add-user-form-label" style={{ marginTop: '15px' }}>
                                    Limit
                                </div>
                                <div className="add-user-form-text-wrapper">
                                    <input
                                        className="sub-add-user-form-text"
                                        type="number"
                                        name="limits"
                                        defaultValue={1}
                                        placeholder="Enter Limit"
                                        onChange={this.onChangeListener}
                                        value={this.state.limits}
                                    />
                                </div>
                            </div>
                            <div style={{ margin: '50px 50px 10px 50px', display: 'flex', justifyContent: 'space-between' }}>
                                <button
                                    className="addcustomer-button-empty-dashboard popup-btn-left btn-ok"
                                    onClick={() => {
                                        this.setState((state) => ({
                                            ...state,
                                            itemAddPopup: false,
                                        }));
                                    }}
                                >
                                    Cancel
                                </button>
                                {this.state.item_id && this.state.limits ? <button
                                    className="add-user-form-submit-button popup-btn-right btn-ok"
                                    onClick={() => {
                                        this.setState((state) => ({
                                            ...state,
                                            itemAddPopup: false,
                                            popupText: "Addning Item Please Wait...",
                                        }), () => {
                                            this.state.editItem ? this.updateSubscriptionPlanItem() : this.addSubPlanItem();
                                        })
                                    }}
                                >
                                    Save
                                </button> : <button style={{ opacity: '0.5' }}
                                    className="add-user-form-submit-button popup-btn-right btn-ok"
                                >
                                    Save
                                </button>}
                            </div>
                        </AnimatedModal>
                        {/* -------------- */}


                        {/* Add Addon popup */}
                        <AnimatedModal
                            isOpen={this.state.addonAddPopup}
                            onRequestClose={() => {
                                this.setState((state) => ({
                                    ...state,
                                    inviteModal: false,
                                }))
                            }}
                            height="460px"
                            width="400px"
                        >

                            <div style={{ textAlign: "center", margin: '20px 0px', height: '40px', fontSize: '22px', fontWeight: '500' }}>{this.state.editItem ? "Edit Addon" : "Add An Addon"}</div>
                            <div style={{ height: '5px', width: '100%' }}><hr /></div>
                            <div style={{ margin: '10px 50px' }}>
                                <div className="add-user-form-label">
                                    Addon Name
                                </div>
                                <div className="add-user-form-text-wrapper">
                                    <div className="add-user-form-text-wrapper">
                                        <input
                                            className="sub-add-user-form-text"
                                            type="text"
                                            name="addon_name"
                                            placeholder="Enter Addon Name"
                                            onChange={this.onChangeListener}
                                            value={this.state.addon_name}
                                        />
                                    </div>
                                </div>
                                <div className="add-user-form-label">
                                    Addon Description
                                </div>
                                <div className="add-user-form-text-wrapper">
                                    <div className="add-user-form-text-wrapper">
                                        <input
                                            className="sub-add-user-form-text"
                                            type="text"
                                            name="addon_desc"
                                            placeholder="Enter Description"
                                            onChange={this.onChangeListener}
                                            value={this.state.addon_desc}
                                        />
                                    </div>
                                </div>


                                <div className="add-user-form-label">
                                    Price
                                </div>
                                <div className="add-user-form-text-wrapper">
                                    <div className="add-user-form-text-wrapper">
                                        <input
                                            className="sub-add-user-form-text"
                                            type="int"
                                            name="addon_price"
                                            placeholder="Enter price"
                                            onChange={this.onChangeListener}
                                            value={this.state.addon_price}
                                        />
                                    </div>
                                </div>


                                
                            </div>
                            <div style={{ margin: '50px 50px 10px 50px', display: 'flex', justifyContent: 'space-between' }}>
                                <button
                                    className="addcustomer-button-empty-dashboard popup-btn-left btn-ok"
                                    onClick={() => {
                                        this.setState((state) => ({
                                            ...state,
                                            addonAddPopup: false,
                                        }));
                                    }}
                                >
                                    Cancel
                                </button>
                                {this.state.item_id && this.state.limits ? <button
                                    className="add-user-form-submit-button popup-btn-right btn-ok"
                                    disabled={this.state.addon_name == '' || this.state?.addon_desc == '' || this.state.addon_price == ''}
                                    onClick={() => {
                                        this.setState((state) => ({
                                            ...state,
                                            addonAddPopup: false,
                                            popupText: "Addning Item Please Wait...",
                                        }), () => {
                                            this.state.editItem ? this.editAddonPlan() : this.addAddonPlan();
                                        })
                                    }}
                                >
                                    Save
                                </button> : <button style={{ opacity: '0.5' }}
                                    className="add-user-form-submit-button popup-btn-right btn-ok"
                                >
                                    Saves
                                </button>}
                            </div>
                        </AnimatedModal>
                        {/* -------------- */}


                        <div className="flights-box"
                            style={{ margin: '20px 0px 0px 0px', padding: '40px', display: 'flex', flexDirection: 'column', alignSelf: 'center', justifySelf: 'center', background: 'none', width: "60vw", height: 'calc(100% - 20px)' }}>
                            <div style={{ display: "flex", justifyContent: "space-between", }}>
                                <div className="services-content-title" style={{ fontSize: '18px' }}>{this.state.plan_name} {this.state.plan_type}</div>
                                <div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        {this.props.location.state.plan.status != 'Archived' ?
                                            <ButtonWithIcon
                                                text={"Archive"}
                                                width="94px"
                                                
                                                onClick={() => {
                                                    this.setState({
                                                        itemName: "Subscription Plan",
                                                        processPopupIcon: "WARNING",
                                                        processAction: "UPDATE",
                                                        processMessage: null,
                                                        showProcessPopup: true,
                                                        isArchive: true,
                                                        ok: false
                                                    })
                                                }}
                                            /> : this.props.location.state.plan.status == 'Archived' ? <ButtonWithIcon
                                                text={"Archived"}
                                                isDisabled={this.props.location.state.plan.status == 'Archived'}
                                                width="94px"

                                            /> : null}

                                                {this.props.location.state.plan.status != 'Archived' ? 
                                                <ButtonWithIcon
                                            text={"Delete"}
                                            width="94px"
                                            onClick={() => {
                                                this.setState({
                                                    itemName: "Subscription Plan",
                                                    processPopupIcon: "WARNING",
                                                    processAction: "DELETE",
                                                    processMessage: null,
                                                    showProcessPopup: true,
                                                    isItem: false,
                                                    ok: false
                                                })
                                            }}
                                        />
                                         : null}
                                        
                                        {this.props.location.state.plan.status != 'Archived' ? <ButtonWithIcon
                                            text={"Save"}
                                            width="94px" isBtnActive
                                            isDisabled={this.state.plan_cost < 1 || !this.state.plan_type || !this.state.plan_status || !this.state.description || this.state.planItems.length < 1}
                                            onClick={() => {
                                                this.updateSubscriptionPlan();
                                            }}
                                        />
                                            : null}

                                    </div>
                                </div>
                            </div>
                            <div className="add-user-form-label">Date created : {dateFormat(this.state.plan_created_date, "dd mmm , yyyy")}</div>
                            <div className='add-user-form-label' style={{ marginTop: '5px' }}>Description</div>
                            <div>
                                <input
                                    readOnly={this.props.location.state.plan.status == 'Archived'}
                                    className="sub-add-user-form-text"
                                    type="text"
                                    name="description"
                                    placeholder="Enter Description"
                                    onChange={this.onChangeListener}
                                    value={this.state.description}
                                />
                            </div>

                            <div style={{ display: "flex", width: '100%', gap: '20px', marginTop: '15px' }}>
                                <div style={{ width: '30%' }}>
                                    <div className='add-user-form-label'>Price</div>
                                    <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                        <input
                                            readOnly={this.props.location.state.plan.status == 'Archived'}
                                            className="sub-add-user-form-text"
                                            type="text"
                                            maxLength={10}
                                            name="plan_cost"
                                            placeholder="Cost"
                                            onChange={this.onChangeListener}
                                            value={this.state.plan_cost}
                                            style={{ width: "90%", paddingLeft: '30px' }}
                                        />
                                        <div style={{ color: "#666666", marginLeft: 'calc(-90% + 10px)' }}>{"₹"}</div>
                                    </div>
                                </div>
                                {this.props.location.state.plan.status != 'Archived' &&
                                    <div style={{ width: '30%' }}>
                                        <div className='add-user-form-label'>Plan Type</div>
                                        <select
                                            name="plan_type"
                                            onChange={this.onChangeListener}
                                            value={this.state.plan_type}
                                            className="sub-add-user-form-text"
                                            style={{ width: "90%" }}
                                        >
                                            <option>Monthly</option>
                                            <option>Yearly</option>
                                        </select>
                                    </div>
                                }

                                {this.props.location.state.plan.status != 'Archived' ? 
                                <div style={{ width: '30%' }}>
                                    <div className="add-user-form-label">Status</div>
                                    <div className="add-user-form-text-wrapper">
                                        <select
                                            name="plan_status"
                                            onChange={this.onChangeListener}
                                            value={this.state.plan_status}
                                            className="sub-add-user-form-text"
                                            style={{ width: "90%" }}
                                        >
                                            <option>Active</option>
                                            <option>Inactive</option>
                                            <option>Archived</option>
                                        </select>
                                    </div>
                                </div>
                                : null}
                                
                            </div>


                            <div style={{ display: "flex", justifyContent: 'space-between', marginTop: '20px' }}>
                                <div className='sub-add-user-form-label'>Subscription Items</div>
                                <div style={{ display: 'flex' }}>
                                    <div className="add-user-form-text-wrapper" style={{ marginLeft: "25px", marginRight: '5px' }}>
                                        <img src={btnAdd} style={{ height: '30px', width: '34px', cursor: 'pointer' }} onClick={() => {
                                            if(this.props.location.state.plan.status != 'Archived'){
                                                this.setState((state) => ({
                                                ...state,
                                                editItem: false,
                                                limits: 1,
                                                item_id: this.state.items[0].id,
                                                itemAddPopup: true,
                                            }));
                                            }
                                            
                                        }} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ height: "calc(100% - 300px)", marginTop: '10px' }} >
                                <TableView
                                    isLoading={this.state.tableLoading}
                                    count={this.state.count}
                                    columns={[
                                        { Header: "Name", accessor: "item_name", width: '40%' },
                                        { Header: "Id", accessor: "item_id", width: '45%' },
                                        { Header: "Limit", accessor: "limits", width: '15%' },
                                    ]}
                                    data={this.state.planItems || []}
                                    user={this.state.user}
                                    // onClickRow={(plan) => {
                                    //     this.props.history.push('/admin/new_subscription', { user, plan })
                                    // }}
                                    onStateChange={(state) => { this.setState({ tableState: state }, () => { this.getSubscriptionPlanItems() }) }}
                                    activities={{
                                        canEdit: true,
                                        onClickEdit: (item) => {
                                            if(this.props.location.state.plan.status != 'Archived'){
                                                this.setState((state) => ({
                                                ...state,
                                                item_id: item.item_id,
                                                limits: item.limits,
                                                editItem: true,
                                                itemAddPopup: true
                                            }))
                                            }
                                            
                                        },
                                        onClickDelete: (item) => {
                                            if(this.props.location.state.plan.status != 'Archived'){
                                                this.setState((state) => ({
                                                ...state,
                                                itemName: "Subscription Item",
                                                processPopupIcon: "WARNING",
                                                processAction: "DELETE",
                                                processMessage: null,
                                                showProcessPopup: true,
                                                item_id: item.item_id,
                                                isItem: true,
                                            }))
                                            }
                                            
                                        }
                                    }}
                                />
                            </div>



                            <div style={{ display: "flex", justifyContent: 'space-between', marginTop: '20px' }}>
                                <div className='sub-add-user-form-label'>Addon Items</div>
                                <div style={{ display: 'flex' }}>
                                    <div className="add-user-form-text-wrapper" style={{ marginLeft: "25px", marginRight: '5px' }}>
                                        {this.state.addons[0] ? null :
                                            <img src={btnAdd} style={{ height: '30px', width: '34px', cursor: 'pointer' }} onClick={() => {
                                                if(this.props.location.state.plan.status != 'Archived'){
                                                    this.setState((state) => ({
                                                    ...state,
                                                    editItem: false,
                                                    limits: 1,
                                                    item_id: this.state.items[0].id,
                                                    addonAddPopup: true,
                                                }));
                                                }
                                                
                                            }} />
                                        }

                                    </div>
                                </div>
                            </div>
                            <div style={{ height: "100px", marginTop: '10px' }} >
                                <TableView
                                    isLoading={this.state.tableLoading}
                                    count={1}
                                    columns={[
                                        { Header: "Addon Name", accessor: "addon_name", width: '40%' },
                                        { Header: "Addon Code", accessor: "zoho_addon_code", width: '45%' },
                                        { Header: "Price", accessor: "price", width: '15%' },
                                    ]}
                                    data={this.state.addons || []}
                                    user={this.state.user}
                                    
                                    onStateChange={(state) => { this.setState({ tableState: state }, () => { this.getSubscriptionPlanItems() }) }}
                                    activities={{
                                        canEdit: true,
                                        onClickEdit: (item) => {
                                            if(this.props.location.state.plan.status != 'Archived'){
                                                this.setState((state) => ({
                                                ...state,
                                                editItem: true,
                                                // limits: 1,
                                                addon_name: item.addon_name,
                                                addon_desc: item.addon_desc,
                                                addon_price: item.price,
                                                addonAddPopup: true,
                                                addonDetail: item
                                            }));
                                            }
                                            
                                        },
                                        onClickDelete: (item) => {
                                            if(this.props.location.state.plan.status != 'Archived'){
                                                this.setState((state) => ({
                                                ...state,
                                                itemName: "Addon Item",
                                                processPopupIcon: "ERROR",
                                                processAction: "UPDATE",
                                                processMessage: "Delete Addon is not allowed",
                                                showProcessPopup: true
                                            }))
                                            }
                                            
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>}
            </div>
        </div>
    }
}

export default newSubscription;

